import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Customer } from '../../model/customer';
import { CustomerService } from '../../services/customer.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { CartService } from '../../services/cart.service';
import { Cart } from '../../model/cart';
import { SnackBarService } from '../../services/snack-bar.service';
import { Subscription } from 'rxjs';
import { errorMapping } from '../../constants/errors';
import { ActivatedRoute } from '@angular/router';
import { DiscountModalService } from '../../services/discount-modal.service';
import { LoadingService } from '../../services/loading.service';
import { DisconnectdSaleStep } from '../../enum/DisconnectedSaleStep';

@Component({
    selector: 'pme-disconnected-sale-product',
    templateUrl: './disconnected-sale-product.component.html',
    styleUrls: ['./disconnected-sale-product.component.scss'],
    standalone: false
})
export class DisconnectedSaleProductComponent implements OnInit {

  @Output() cartUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() productName: string;
  @Input() productFamily: string;
  @Input() valuePerMonth: string;
  @Input() totalValue: string;
  @Input() productImg: string;
  @Input() installments: number;
  @Input() firstStep: boolean = true;
  @Input() productValue: string;
  @Input() discountedValue: string;

  showDetail: boolean = false;
  cart: Cart;

  isCheckoutSuccessfull: boolean;

  disconnetedSaleStepEnum = DisconnectdSaleStep;
  currentDisconnetedSaleStep: string;


  constructor(
    private sessionStorageService: SessionStorageService,
    public cartService: CartService,
  ) {
    this.cart = this.cartService.getCurrentCart();
    this.currentDisconnetedSaleStep = this.sessionStorageService.getCustomData('disconnectedSaleStep');
    this.isCheckoutSuccessfull = Boolean(JSON.parse(this.sessionStorageService.getCustomData('isCheckoutSuccessfull')));
  }

  ngOnInit(): void {

  }

  ngOnChanges() {
    this.valuePerMonth = this.formatValue(this.valuePerMonth);

    this.totalValue = this.formatValue(this.totalValue);

    this.discountedValue = this.formatValue(this.discountedValue);

    this.cart = this.cartService.getCurrentCart();
  }

  formatValue(value: any): string {
    if (value === null || value === undefined) {
      return '0,00';
    }
    
    value = String(value);
    value = Number(value.replace(',', '.')).toFixed(2).replace('.', ',');
    return value;
  }

  updateProduct(event: any) {
    this.productValue = event.productValue;
    this.discountedValue = event.discountedValue;
    this.totalValue = event.totalValue;
  }

  handleCartUpdate(event: any) {
    this.cartUpdated.emit(event);
  }

  clickDropdown() {
    this.showDetail = !this.showDetail;
  }
}
